<script>
import { inject } from "vue";
import { dateFormatter } from "@/use/utilities/time/dateFormatter";
import { useStateIcon } from "@/composables/useStateIcon";

export default {
  name: "PhaseState",
  props: {
    phase: { type: Object, required: true },
    state: { type: Object, required: true },
    withUser: { type: Boolean, default: false },
  },
  setup() {
    const { states } = inject("constants");
    const { getTwqPhaseStateIcon } = useStateIcon();

    const getClassFromSlug = (slug) => {
      switch (slug) {
        case states.COMPLETED:
          return "bg-blue";
        default:
          return "btn-red";
      }
    };

    return { dateFormatter, getTwqPhaseStateIcon, getClassFromSlug };
  },
};
</script>

<template>
  <li class="d-flex align-items-start flex-column">
    <div class="w-100 d-flex">
      <img
        class="me-2"
        :src="require(`@/assets/icons/${getTwqPhaseStateIcon(state?.slug)}.svg`)"
        width="25"
      />
      <div class="d-flex justify-content-between w-100">
        <span>
          <span>{{ state?.name }} - {{ phase.internal_phase?.name }}</span>
          <span v-if="withUser">
            ({{ phase.user?.first_name }} {{ phase.user?.last_name }})
          </span>
        </span>
        <small class="mb-1 text-muted">
          {{ state?.pivot?.user?.first_name }}
          {{ state?.pivot?.user?.last_name }}
          {{ state?.pivot?.user && "-" }}
          {{ dateFormatter(state?.pivot?.created_at) }}
        </small>
      </div>
    </div>
    <template v-if="state?.pivot?.feedback_notes?.length">
      <div class="my-2 d-flex w-100 flex-column">
        <div v-for="(feedbackNote, index) in state?.pivot?.feedback_notes" :key="index">
          <div
            class="rounded-custom p-2 mb-2"
            :class="getClassFromSlug(state?.slug)">
            <div class="d-flex flex-column">
              <p>{{ feedbackNote.feedback?.description ?? "Nota interna" }}</p>
              <p>{{ feedbackNote.note }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <p class="ms-5 text-muted">Nessuna nota</p>
    </template>
  </li>
</template>
